import { type EnvironmentId, type OrchestrationEvent } from "@cmmd-forge/contracts";
import { type EnvironmentConnection } from "./connection";

export type ThreadDetailSubscriptionDependencies = {
  readonly applyEvent: (event: OrchestrationEvent, environmentId: EnvironmentId) => void;
  readonly readConnection: (environmentId: EnvironmentId) => EnvironmentConnection | null;
  readonly subscribeConnections: (listener: () => void) => () => void;
};

let dependencies: ThreadDetailSubscriptionDependencies | null = null;

export function configureThreadDetailSubscriptionDependencies(
  nextDependencies: ThreadDetailSubscriptionDependencies,
): void {
  dependencies = nextDependencies;
}

export function readThreadDetailSubscriptionDependencies(): ThreadDetailSubscriptionDependencies {
  if (dependencies === null) {
    throw new Error("Thread detail subscriptions were used before the service was configured.");
  }
  return dependencies;
}
